import { Outlet } from "react-router-dom";
import DataManagementTabs from "./components/DataManagementTabs";

const DataManagementPage = () => {
  return (
    <div className="space-y-5">
      <DataManagementTabs />
      <Outlet />
    </div>
  );
};

export default DataManagementPage;
